import React from 'react';
import {
  Camera, Image, AR, Play, ThreeSixtySpin, Ruler, SpecialSavings
} from '@one-thd/sui-icons';

export const MEDIA_TYPE_LABELS = {
  IMAGE: 'Images',
  VIDEO: 'Videos',
  THREESIXTY: '360° View',
  CUSTOMER_IMAGE: 'Customer Images',
  MEASUREMENT: 'Measurements',
  HOTSPOTS: 'Shop This Look',
  AR: 'See This In My Room'
};

export const MEDIA_TYPE_ICONS = {
  IMAGE: <Image />,
  VIDEO: <Play />,
  THREESIXTY: <ThreeSixtySpin />,
  AR: <AR />,
  CUSTOMER_IMAGE: <Camera />,
  MEASUREMENT: <Ruler />,
  HOTSPOTS: <SpecialSavings />
};

export const MEDIA_GALLERY_CONTAINER_MAXWIDTH = '800px';
export const MEDIA_GALLERY_CONTAINER_HEIGHT = '600px';
export const MEDIA_GALLERY_CONTAINER_MAXHEIGHT = '600px';
export const MEDIA_GALLERY_HOTSPOTS_MAXWIDTH = '100%';
export const MEDIA_GALLERY_THUMBNAILS_WIDTH = '800px';
export const GRID_THUMBNAIL_WIDTH = '450px';
export const GRID_THUMBNAIL_HEIGHT = '650px';
export const THUMBNAIL_OVERLAY_COLOR = 'rgba(32, 32, 32, 0.333)';
export const OVERLAY_CAROUSEL_CONTAINER_WIDTH = '650px';
export const OVERLAY_CAROUSEL_CONTAINER_HEIGHT = '650px';
export const OVERLAY_VIDEO_CONTAINER_WIDTH = '1000px';

export const STANDARD_IMAGE_CLASSES = [
  'sui-w-full',
  'sui-h-full',
  'sui-max-h-[650px]',
  'sui-max-w-[650px]',
  'sui-m-auto',
  '2xl:sui-max-w-[650px]',
  '2xl:sui-max-h-[650px]',
  'lg:sui-max-w-[500px]',
  'lg:sui-max-h-[500px]',
  'max-h-[768px]:sui-max-w-[500px]',
  'max-h-[768px]:sui-max-h-[500px]'
].join(' ');
